<h5 class="mt-0">More Topics</h5>
<p *ngFor="let data of helpData">
    <a
        [routerLink]="['/category', data.categoryId]"
        title="{{ data.categoryTitle }}"
        class="text-dark"
        >
        <u>{{ data.categoryTitle }}</u>
    </a>
</p>
<p class="mt-6"><a routerLink="/home" title="Return to the Help Center home page">Return to Help Center Home</a></p>